import ReceiptSummary from '../../pages/Receipt/ReceiptSummary';
import React, { useState } from 'react';

const ReceiptSummaryContainer = ({ closeModal }) => {
	const [editReceipt, setEditReceipt] = useState(false);

	const goToEditReceipt = () => {
		setEditReceipt(true);
	};

	return (
		<ReceiptSummary
			closeModal={closeModal}
			editReceipt={editReceipt}
			goToEditReceipt={goToEditReceipt}
		/>
	);
};

export default ReceiptSummaryContainer;
